import { redirect } from "react-router-dom";
import { WELCOME_PATH } from "../../../../constants/env";
import { authGuardService } from "../services/auth.guard.service";
import type { GuardLoaderOptions } from "../types/guard.type";

export function createAuthLoader(options: Readonly<GuardLoaderOptions> = {}) {
  const { redirectTo = WELCOME_PATH } = options;

  return async function authLoader() {
    const { allowed } = authGuardService.check();
    if (!allowed) {
      return redirect(redirectTo);
    }

    return null;
  };
}

export const authLoader = createAuthLoader();
